import { render, staticRenderFns } from "./CourseDetailPage.vue?vue&type=template&id=5d76f067&scoped=true"
import script from "./CourseDetailPage.vue?vue&type=script&lang=js"
export * from "./CourseDetailPage.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailPage.vue?vue&type=style&index=0&id=5d76f067&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d76f067",
  null
  
)

export default component.exports